/**
 * Two column content layout
 */

import React from "react"
import { wrapper, left, right } from "./TwoColumnContent.module.scss"

const TwoColumnContent = ({ children, padding = true }) => {
  if (!children.length) {
    children = [children]
  }

  return (
    <div className={wrapper} data-padding={padding}>
      <div className={left} data-padding={padding}>
        {children[0]}
      </div>
      <div className={right} data-padding={padding}>
        {children[1]}
      </div>
    </div>
  )
}

export default TwoColumnContent
